
import { Header } from "../../components/Header"
import { AppRoute } from "./routes/AppRoute"

export const AppTrafficTickets = () => {
  return (
        <section className="h-[100vh]" id="mainContent">
            <Header/>
            <div className="h-[89vh] w-full flex bg-[#f4f5f5] sans-Roboto overflow-scroll">
              <AppRoute />
            </div>
        </section>
  )
}
